/**
 * API yapılandırma ve yardımcı fonksiyonları
 */

// API temel URL'ini al
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8012/api';

/**
 * Güvenli API URL oluşturma
 * @param path API endpoint yolu (başında / olmamalı)
 * @returns Tam API URL'i
 */
export const getApiUrl = (path: string): string => {
  // Boş durumları kontrol et
  if (!path) return API_BASE_URL;
  
  // Path başında / varsa kaldır
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  // API_BASE_URL sonunda / varsa ve path başında / varsa düzelt
  return `${API_BASE_URL}/${cleanPath}`;
};

/**
 * API istek başlıkları
 */
export const defaultHeaders = {
  'Content-Type': 'application/json',
};

/**
 * Multipart form verisi için başlıklar
 */
export const multipartHeaders = {
  // Multipart form data için Content-Type başlığını axios otomatik ekler
};

/**
 * API istek yapılandırması
 */
export const apiConfig = {
  baseURL: API_BASE_URL,
  headers: defaultHeaders,
  timeout: 30000, // 30 saniye
};
